export default "__VITE_ASSET__Du8knOFP__"